import React from 'react';

import { Box, Typography } from '@mui/material';
import { TextFieldCDS } from 'app/shared/componentsRestyled/coreDesignSystem/form';
import PropTypes from 'prop-types';

import { CIC_SAVE_NOTE_MAX_LENGTH, CIC_SAVE_REASON_NAME } from 'constants/cicReason';

import {
  CIC_SAVE_REASON_MODAL_DESCRIPTION,
  CIC_SAVE_REASON_NOTE_LABEL,
} from './CicSaveReasonModal.constants';
import { containerStyles, reasonRowStyles, triggerFieldsStyles } from './CicSaveReasonModal.styles';
import { CicSaveReasonModalTestIds } from './CicSaveReasonModal.testIds';

const CicSaveReasonModal = ({ triggerFields, note, error, isLoading, onNoteChange }) => {
  return (
    <Box data-testid={CicSaveReasonModalTestIds.CIC_SAVE_REASON_MODAL_CONTENT} sx={containerStyles}>
      <Typography color="text.secondary" variant="regular14">
        {CIC_SAVE_REASON_MODAL_DESCRIPTION}
      </Typography>

      {!!triggerFields?.length && (
        <Box sx={triggerFieldsStyles}>
          {triggerFields.map(field => (
            <Typography key={field} variant="bold14">
              {field}
            </Typography>
          ))}
        </Box>
      )}

      <Box sx={reasonRowStyles}>
        <Typography color="text.secondary" variant="regular14">
          Reason:
        </Typography>
        <Typography variant="bold14">{CIC_SAVE_REASON_NAME}</Typography>
      </Box>

      <TextFieldCDS
        multiline
        required
        dataTestId={CicSaveReasonModalTestIds.CIC_SAVE_REASON_MODAL_NOTE_INPUT}
        disabled={isLoading}
        error={!!error}
        helperText={error}
        label={CIC_SAVE_REASON_NOTE_LABEL}
        maxLength={CIC_SAVE_NOTE_MAX_LENGTH}
        name="cicSaveReasonNote"
        placeholder={`${CIC_SAVE_NOTE_MAX_LENGTH} max character limit`}
        rows={4}
        value={note}
        variant="outlined"
        onChange={onNoteChange}
      />
    </Box>
  );
};

CicSaveReasonModal.propTypes = {
  onNoteChange: PropTypes.func.isRequired,
  triggerFields: PropTypes.arrayOf(PropTypes.string),
  note: PropTypes.string,
  error: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default CicSaveReasonModal;
